import { languages } from '@shared/library/dist/static/language';
import axios from 'axios';
import React, { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import config from '../../../config';
import formDataValidator from '../../../helpers/formData';
import importer from '../../../helpers/importer';
import '../Login/LogIn.scss';
//ICONS
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
//#region COMPONENTS
import Alert from '@mui/material/Alert';
import { GestCard } from '@shared/library';
import {
    CustomButton,
    CustomInput,
} from '../../_gest';
//#endregion
//CONTEXTS
import { CntxConfig } from '../../WebGest';

const ForgotPassword = () => {
    //CONTEXTS USE
    const cntxConfig = useContext(CntxConfig);

    //STATIC DATA
    const navigate = useNavigate();
    const lang = languages(cntxConfig?.settings?.lang);

    //#region STATES
    const [sendAgainTimer, setSendAgainTimer] = React.useState(61);
    const username = React.useRef("");
    //FLAGS
    const [errorAnimation, setErrorAnimation] = React.useState(false);
    const [submitOK, setSubmitOK] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    //#endregion

    //#region METHODS

    //#region API CALLS
    const resetPasswordAPI = (e?: any) => {
        if (e) {
            e.preventDefault();
            username.current = (formDataValidator(e.target, 'object') as { username: string; }).username;
        }

        if (username.current) {
            setLoading(true);

            axios.post(`${config.api.internal}/Auth/resetPassword`, { username: username.current })
                .then(() => setSubmitOK(true))
                .catch(() => {
                    animateError();
                    username.current = "";
                })
                .finally(() => setLoading(false));
        }
        else {
            animateError();
        }

    };

    const sendAgain = useCallback(() => {
        if (submitOK && username.current) {
            resetPasswordAPI();
        }
    }, [submitOK, username.current]);
    //#endregion

    const animateError = () => {
        setErrorAnimation(true);
        setTimeout(() => {
            setErrorAnimation(false);
        }, 100);
    };
    //#endregion

    //STATES CHANGE
    React.useEffect(() => {
        if (submitOK && sendAgainTimer > 0) {
            setTimeout(() => {
                setSendAgainTimer(sendAgainTimer - 1);
            }, 1000);
        }
    }, [submitOK, sendAgainTimer]);

    return (
        <GestCard type="floating" id="Login" style={{ width: '350px' }}>
            <div className="logo">
                <img className={`mb-3 ${loading ? 'spin' : ''} ${errorAnimation ? 'shake' : ''} `} src={importer.img.require('Logo.svg')} alt="" />
                <h4 className='mb-0'>{lang.reset_password}</h4>
            </div>
            <div className='my-4'>
                {
                    submitOK
                        ?
                        <>
                            <Alert icon={false}>

                                <p className='m-0 mb-1 text-justify'>
                                    {lang.password_request_completed}
                                </p>
                                <p className='m-0 text-justify'>
                                    {lang.check_your_inbox}
                                </p>
                                <div className='mt-2 w-100 justify-content-center'>
                                    <EmailRoundedIcon fontSize='large' />
                                </div>

                                <span className='d-flex text-xs'>
                                    {lang.didnt_receive_email}
                                    &nbsp;
                                    {
                                        <a
                                            onClick={() => {
                                                if (!sendAgainTimer) {
                                                    sendAgain();
                                                    setSendAgainTimer(61);
                                                }
                                            }}

                                            className={sendAgainTimer ? 'text-disabled' : ''}
                                        >
                                            {lang.send_again}
                                        </a>
                                    }
                                    &nbsp;
                                    {sendAgainTimer ? `(${sendAgainTimer})` : ''}
                                </span>

                            </Alert>

                            <a className='mt-2' onClick={() => { navigate('/login'); }}><strong>{lang.back_to_login}</strong></a>

                        </>
                        :
                        <form onSubmit={resetPasswordAPI}>
                            <fieldset>
                                <CustomInput name="username" variant="cloud" img={importer.ic.require('user.svg')} placeholder={lang.username} class="mb-2"></CustomInput>
                            </fieldset>
                            <div>
                                <CustomButton variant="primary" type={"submit"} class="w-100 mb-2">{lang.reset}</CustomButton>
                                <a className='' onClick={() => { navigate('/login'); }}><strong>{lang.back_to_login}</strong></a>
                            </div>
                        </form>
                }


            </div>
        </GestCard>
    );
};
export default React.memo(ForgotPassword);


// http://localhost:3001/